import React, { createContext, useContext, useState } from 'react';

const SearchModalContext = createContext({
    isSearchModalOpen: null,
    openSearchModal: () => {}, 
    closeSearchModal: () => {},
});

const DetailModalContext = createContext({
    isDetailModalOpen: null,
    openDetailModal: () => {},
    closeDetailModal: () => {},
});

const FaceOnUploadModalContext = createContext({
    isFaceOnUploadModalOpen: false,
    openFaceOnUploadModal: () => {},
    closeFaceOnUploadModal: () => {},
});

const CustomPlayerModalContext = createContext({
    isCustomPlayerModalOpen: null,
    openCustomPlayerModal: () => {},
    closeCustomPlayerModal: () => {}
})

export const useSearchModal = () => useContext(SearchModalContext);
export const useDetailModal = () => useContext(DetailModalContext);
export const useFaceOnUploadModal = () => useContext(FaceOnUploadModalContext);
export const useCustomPlayerModal = () => useContext(CustomPlayerModalContext);

export function ModalProvider({ children }) {

    const [isSearchModalOpen, setIsSearchModalOpen] = useState(null);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(null);
    const [isFaceOnUploadModalOpen, setIsFaceOnUploadModalOpen] = useState(false);
    const [isCustomPlayerModalOpen, setIsCustomPlayerModalOpen] = useState(null);
    
    const openSearchModal = (position) => setIsSearchModalOpen(position);
    const closeSearchModal = () => setIsSearchModalOpen(null);

    const openDetailModal = (position) => setIsDetailModalOpen(position);
    const closeDetailModal = () => setIsDetailModalOpen(null);

    const openFaceOnUploadModal = () => setIsFaceOnUploadModalOpen(true);
    const closeFaceOnUploadModal = () => setIsFaceOnUploadModalOpen(false);

    const openCustomPlayerModal = (position) => setIsCustomPlayerModalOpen(position);
    const closeCustomPlayerModal = () => setIsCustomPlayerModalOpen(null);

    const searchModalContextValue = {
        isSearchModalOpen,
        openSearchModal,
        closeSearchModal,
    };

    const detailModalContextValue = {
        isDetailModalOpen,
        openDetailModal,
        closeDetailModal,
    };

    const faceOnUploadModalContextValue = {
        isFaceOnUploadModalOpen,
        openFaceOnUploadModal,
        closeFaceOnUploadModal,
    };

    const customPlayerModalContextValue = {
        isCustomPlayerModalOpen,
        openCustomPlayerModal,
        closeCustomPlayerModal
    }

    return (
        <SearchModalContext.Provider value={searchModalContextValue}>
            <DetailModalContext.Provider value={detailModalContextValue}>
                <FaceOnUploadModalContext.Provider value={faceOnUploadModalContextValue}>
                    <CustomPlayerModalContext.Provider value={customPlayerModalContextValue}>
                        {children}
                    </CustomPlayerModalContext.Provider>
                </FaceOnUploadModalContext.Provider>
            </DetailModalContext.Provider>
        </SearchModalContext.Provider>
    );
}